export default "__VITE_ASSET__CZ92JD2n__"